import { ReactNode } from "react";

export type Props = {
  /** Content to render inside the auth container */
  children: ReactNode;
  /** Title text */
  title: string;
  /** Description text */
  description: string;
  /** Render function for header (logo, title, description) */
  renderHeader: (props: { title: string; description: string }) => ReactNode;
  /** Outer container className */
  className?: string;
  /** Inner content className */
  contentClassName?: string;
};

/**
 * Base auth page content wrapper component - unstyled, uses render props for flexibility.
 * Wrap with styled version in shared/features/auth.
 */
export function AuthPageContentBase({
  children,
  title,
  description,
  renderHeader,
  className,
  contentClassName,
}: Props) {
  return (
    <div className={className} data-testid="auth-content">
      {renderHeader({ title, description })}
      <div className={contentClassName} data-testid="auth-content-body">
        {children}
      </div>
    </div>
  );
}

export default AuthPageContentBase;
